import { ToolbarElement } from './ToolbarElement'

const searchPanelTemplate = `
<div class="toolbar-search-row">
  <div class="box">
    <input type="text" />
    <div class="result">0/0</div>
  </div>
  <div class="button prev" data-name="prev"></div>
  <div class="button next" data-name="next"></div>
  <div class="button case" data-name="case">Aa</div>
  <div class="button more" data-name="more"></div>
  <div class="button close" data-name="close"></div>
</div>
<div class="toolbar-replace-row">
  <div class="box">
    <input type="text" />
  </div>
  <div class="button replace" data-name="replace">Replace</div>
  <div class="button replace-all" data-name="replace-all">Replace All</div>
</div>
`

export class ToolbarSearchElement extends ToolbarElement {
  public entryElement = document.createElement('div')
  public overlayElement: HTMLDivElement
  protected keywordInput: HTMLInputElement
  protected showReplace = false
  protected caseSensitive = false
  protected showPanel = false

  constructor(overlayContainer: HTMLDivElement, public readonly name: string) {
    super(overlayContainer)
    this.overlayElement = document.createElement('div')
    this.initDom()
    this.keywordInput = this.overlayElement.querySelector('.toolbar-search-row input') as HTMLInputElement
    this.initEvent()
  }

  public getEntryElement(): HTMLElement {
    return this.entryElement
  }

  public override setSearchResult(index: number, count: number) {
    const resultElement = this.overlayElement.querySelector('.result') as HTMLDivElement
    const showCount = count ?? 0
    const showIndex = showCount > 0 ? (index ?? 0) + 1 : 0
    resultElement.innerHTML = `${showIndex}/${showCount}`
  }

  protected initDom() {
    this.entryElement.classList.add(`toolbar-button-${this.name}`, 'toolbar-button')
    this.overlayElement.classList.add('toolbar-search-panel')
    this.overlayElement.innerHTML = searchPanelTemplate
    this.overlayContainer.appendChild(this.overlayElement)
  }

  protected initEvent() {
    this.entryElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.overlayElement.addEventListener('mousedown', (event) => {
      if (!(event.target instanceof HTMLInputElement)) {
        event.preventDefault()
      }
    })
    this.entryElement.addEventListener('click', () => {
      if (!this.showPanel) {
        this.showOverlay()
        if (this.keywordInput.value.length > 0) {
          this.emitSearch()
        }
      } else {
        this.hideOverlay()
      }
    })
    this.overlayElement.addEventListener('click', (event) => {
      const target = event.target as HTMLElement
      if (target.classList.contains('button')) {
        switch (target.dataset.name) {
          case 'more': {
            if (this.showReplace) {
              target.classList.remove('selected')
              this.overlayElement.querySelector('.toolbar-replace-row')?.classList.remove('show')
              this.showReplace = false
            } else {
              target.classList.add('selected')
              this.overlayElement.querySelector('.toolbar-replace-row')?.classList.add('show')
              this.showReplace = true
            }
            break
          }
          case 'case': {
            this.caseSensitive = !this.caseSensitive
            if (this.caseSensitive) {
              this.overlayElement.querySelector('.case')?.classList.add('selected')
            } else {
              this.overlayElement.querySelector('.case')?.classList.remove('selected')
            }
            this.emitSearch()
            break
          }
          case 'replace':
          case 'replace-all': {
            const replaceWords = (this.overlayElement.querySelector('.toolbar-replace-row input') as HTMLInputElement)
              .value
            this.emit(`search-replace`, replaceWords, target.dataset.name === 'replace-all')
            break
          }
          case 'close': {
            this.hideOverlay()
            break
          }
          default: {
            this.emit(`search-${target.dataset.name}`)
          }
        }
      }
    })
    this.keywordInput.addEventListener('input', this.emitSearch.bind(this))
  }

  protected emitSearch() {
    this.emit(`search`, this.keywordInput.value, this.caseSensitive)
  }

  protected showOverlay() {
    const overlayElementWidth = 384
    const entryElementHeight = 32
    const topOffset = 9
    const entryBounding = this.entryElement.getBoundingClientRect()
    const overlayContainerBounding = this.overlayContainer.getBoundingClientRect()

    this.showPanel = true
    this.overlayElement.style.left = `${Math.max(
      Math.min(
        entryBounding.left - overlayContainerBounding.left - overlayElementWidth / 2 + entryBounding.width / 2,
        overlayContainerBounding.width - overlayElementWidth - 5,
      ),
      5,
    )}px`
    this.overlayElement.style.top = `${
      entryBounding.top - overlayContainerBounding.top + entryElementHeight + topOffset
    }px`
    this.overlayElement.style.display = 'block'
  }

  protected hideOverlay() {
    this.showPanel = false
    this.overlayElement.style.display = 'none'
    this.emit('search-clear')
  }
}
